import { useSelector } from "react-redux";
import { useAppDispatch } from "hooks/hooks";
import Modal from "components/Modal/Modal";
import { toast } from "react-toastify";

import {
  deleteAccountReceivable,
  getAllAccountReceivables,
  selectAccountReceivableForDeletion,
  selectState,
  setIndexForDeletionAccountReceivable,
} from "../accountReceivable.slice";

const DeleteAccountReceivableModal = () => {
  const { deleteAccountReceivableModalOpen } = useSelector(selectState);
  const accountReceivable = useSelector(selectAccountReceivableForDeletion);
  const dispatch = useAppDispatch();

  const close = () => {
    dispatch(setIndexForDeletionAccountReceivable(-1));
  };

  const doDelete = async () => {
    try {
      await dispatch(
        deleteAccountReceivable(
          accountReceivable.accountReceivable.receivableId
        )
      ).unwrap();
      dispatch(
        getAllAccountReceivables(accountReceivable.accountReceivable.partnerId)
      );
      toast.success("Uspesno obrisan.");
      close();
    } catch (status: any) {
      close();
      if (status === 406) {
        toast.info("Brisanje fakture nije moguće dok postoje evidentirane uplate.");
      } else if (status === 404 || status === 400) {
        toast.info("Brisanje fakture nije moguće jer postoji neki neočekivani problem sa ovom fakturom.");
      }
    }
  };

  return (
    <Modal
      isOpen={deleteAccountReceivableModalOpen}
      onClick={doDelete}
      onClose={close}
      title="Brisanje potraživanja"
    >
      <p className="info-msg">
        Da li ste sigurni da želite da obrišete sledeće potraživanje?
        <br />
        <br />
        <b>
          br. fakture - {accountReceivable?.accountReceivable.invoiceId}
          <br />
          za posao - {accountReceivable?.project.name}
        </b>
      </p>
    </Modal>
  );
};

export default DeleteAccountReceivableModal;
